
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class AppConfig {
   
  public apiUrl: string | undefined;
  public apiPath: string | undefined;
  public mpsaFlag: string | undefined;
  public dmbrapplog: string | undefined;
  public dmbrwsmtlog: string | undefined;
  public v360applog: string | undefined;
  public v360wsmtlog: string | undefined;


   constructor(private http: HttpClient) {}

    load(url:string):Promise<any> {
        const promise = this.http.get(url)
        .toPromise()
        .then(data => {
          Object.assign(this, data);
          return data;
        });

      return promise;
    }

  
}